import type { Options } from "highcharts";

import { ColumnChartGraph } from "@similarweb/pro-logic-components";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { GenericEmptyState } from "app/components/React/empty-state/GenericEmptyState";
import { useTranslation } from "pro-features/components/WithTranslation";

import { WidgetCard } from "../WidgetCard";

import { useTooltipConfig } from "./chart-tooltip";
import { useChartData } from "./hooks/useChartData";
import { useLegends } from "./hooks/useLegends";

const MeVsCompetitorsChart = () => {
    const translate = useTranslation();
    const { categories, series, isLoading } = useChartData();
    const { legendDataAdapter } = useLegends();
    const tooltipConfig = useTooltipConfig();

    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                width="100%"
                height="100%"
            />
        );
    }

    if (!series.length) {
        return (
            <Flex
                flexGrow="1"
                alignItems="center"
                justifyContent="center"
                height="100%"
            >
                <GenericEmptyState title={translate("global.nodata.notavilable")} />
            </Flex>
        );
    }

    const graphConfig = {
        chart: {
            height: "240px",
        },
        xAxis: {
            type: "category",
            categories,
        },
        yAxis: {
            labels: {
                formatter: function () {
                    return `${this.value}%`;
                },
            },
        },
        plotOptions: {
            column: {
                grouping: false,
                shadow: false,
                borderWidth: 0,
            },
        },
        tooltip: tooltipConfig,
    } satisfies Options;

    return (
        <ColumnChartGraph
            data={series}
            graphConfig={graphConfig}
            legendDataAdapter={legendDataAdapter}
            isSelectableCheckboxes={false}
            shouldPresentValueAtLegend
        />
    );
};

export const MeVsCompetitorsChartContainer = () => {
    const translate = useTranslation();

    return (
        <WidgetCard
            title={translate("bt.report.channels.me-vs-competitors-chart.title")}
            tooltip={translate("bt.report.channels.me-vs-competitors-chart.tooltip")}
            automationIds={{
                title: "me-vs-competitors-chart-title",
                body: "me-vs-competitors-chart-body",
            }}
        >
            <Box
                padding="12px 16px"
                height="100%"
                width="100%"
            >
                <MeVsCompetitorsChart />
            </Box>
        </WidgetCard>
    );
};
